import FormDropdownObjectsField from "components/atoms/FormDropdownObjectsField";
import { openNewInternalLink } from "constants/navigation";
import { getNestedValue } from "utils/getNestedValue";

const Dropdown = ({ dropdownParams, record, feedType }) => {
    const mutation = dropdownParams.mutateDataQuery
        ? dropdownParams.mutateDataQuery({
              feedType,
              defaultPageSize: dropdownParams.defaultPageSize,
          })
        : null;

    if (dropdownParams.optionsQuery?.isLoading) {
        return (
            <FormDropdownObjectsField
                placeholder="Loading..."
                selectedOption={{ key: "Loading...", value: "Loading..." }}
                allOptions={[{ key: "Loading...", value: "Loading..." }]}
                setSelectedOption={() => {}}
                disabled={true}
            />
        );
    }

    return (
        <FormDropdownObjectsField
            optionStyling={dropdownParams.optionStyling}
            defaultOptionStyling={dropdownParams.defaultOptionStyling}
            placeholder={dropdownParams.placeholder}
            selectedOption={
                dropdownParams.key
                    ? {
                          key: getNestedValue(record, dropdownParams.key),
                          value: getNestedValue(record, dropdownParams.key),
                      }
                    : dropdownParams.defaultSelectedOptionValue || {
                          key: "",
                          value: "",
                      }
            }
            allOptions={
                dropdownParams.optionsQuery?.data
                    ? Array.isArray(dropdownParams.optionsQuery.data)
                        ? dropdownParams.optionsQuery.data.map((option) => ({
                              key: option[dropdownParams.optionsKey || "id"],
                              value: option[dropdownParams.optionsValue || "id"],
                          }))
                        : Object.entries(dropdownParams.optionsQuery?.data).map(
                              ([key, value]) => ({ key, value })
                          )
                    : []
            }
            setSelectedOption={(selectedOption) => {
                if (mutation) {
                    const field = dropdownParams.field || dropdownParams.key;
                    mutation.mutate({
                        field,
                        [field]: selectedOption,
                        id: record.id,
                    });
                }
                if (dropdownParams.goToLinks?.[selectedOption]) {
                    openNewInternalLink(
                        `${dropdownParams.goToLinks?.[selectedOption]}${record.id}/`,
                        false
                    );
                }
            }}
        />
    );
};

export default Dropdown;
